import { render, staticRenderFns } from "./reportData.vue?vue&type=template&id=37155d96&scoped=true&"
import script from "./reportData.vue?vue&type=script&lang=js&"
export * from "./reportData.vue?vue&type=script&lang=js&"
import style0 from "./reportData.vue?vue&type=style&index=0&id=37155d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37155d96",
  null
  
)

export default component.exports